import React, { useState } from "react";
import { useLanguage } from "../../../../context/LanguageContext";
import { useAdminSettingsTranslation } from "../translations";
import { updateTaxSettings } from "../../../../firebase/settings-functions";

const TaxTab = ({ storeData, handleChange, handleTaxRateChange, storeId, setError }) => {
    const [saving, setSaving] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState("");
    const { language } = useLanguage();
    const { t } = useAdminSettingsTranslation(language);

    // Save tax settings
    const handleSaveTax = async () => {
        if (!storeId) {
            setError && setError("Store ID is not configured.");
            return;
        }

        setSaving(true);
        setSaveSuccess("");

        try {
            await updateTaxSettings(storeId, {
                rate: storeData.taxRate,
                included: storeData.taxIncluded
            });
            setSaveSuccess(t('taxSettingsSaved') || "Tax settings saved successfully!");

            // Clear success message after 3 seconds
            setTimeout(() => setSaveSuccess(""), 3000);
        } catch (err) {
            setError && setError(err.message || "Failed to save tax settings");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="tax-settings-section">
            <h2>{t('taxSettings')}</h2>

            <div className="tax-settings-container">
                <div className="form-group">
                    <label htmlFor="taxRate">{t('taxRate')}</label>
                    <input
                        type="number"
                        id="taxRate"
                        name="taxRate"
                        value={storeData.taxRate * 100}
                        onChange={handleTaxRateChange}
                        min="0"
                        step="0.01"
                        max="100"
                    />
                    <p className="form-help">Enter tax rate percentage (e.g., 5 for 5% VAT)</p>
                </div>

                <div className="form-checkbox">
                    <input
                        type="checkbox"
                        id="taxIncluded"
                        name="taxIncluded"
                        checked={storeData.taxIncluded}
                        onChange={handleChange}
                    />
                    <label htmlFor="taxIncluded">{t('taxIncluded')}</label>
                    <p className="form-help">
                        If checked, the displayed product prices already include tax.
                        If unchecked, tax will be calculated and added at checkout.
                    </p>
                </div>
            </div>

            {/* Save Button */}
            <div className="settings-form-actions" style={{ marginTop: '20px' }}>
                {saveSuccess && <div className="admin-success-message">{saveSuccess}</div>}
                <button
                    type="button"
                    className="admin-primary-btn save-settings-btn"
                    onClick={handleSaveTax}
                    disabled={saving}
                >
                    {saving ? (t('saving') || 'Saving...') : (t('saveTaxSettings') || 'Save Tax Settings')}
                </button>
            </div>
        </div>
    );
};

export default TaxTab;